import {createContext} from 'react';

const RootContext = createContext("Loading...");
export default RootContext